import { render } from "./WorkerManagement.vue?vue&type=template&id=44df1cae&scoped=true&ts=true"
import script from "./WorkerManagement.vue?vue&type=script&lang=ts"
export * from "./WorkerManagement.vue?vue&type=script&lang=ts"

import "./WorkerManagement.vue?vue&type=style&index=0&id=44df1cae&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44df1cae"]])

export default __exports__